/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseEducatorManagementDash from "../../components/CourseEducatorManagement";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const EducatorManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.courseEducator?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CourseEducatorManagementDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default EducatorManagement;
